import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBrandsProps, IconRender } from '../types.ts';

const Xandr = React.forwardRef<SVGSVGElement | null, IconBrandsProps>(function Xandr({ colored, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.71425 3.51436C6.89062 3.19689 7.22524 3 7.5884 3L16.4116 3C16.7748 3 17.1094 3.19689 17.2858 3.51436L21.7302 11.5144C21.898 11.8164 21.898 12.1836 21.7302 12.4856L17.2858 20.4856C17.1094 20.8031 16.7748 21 16.4116 21H7.5884C7.22524 21 6.89061 20.8031 6.71424 20.4856L2.2698 12.4856C2.10201 12.1836 2.10201 11.8164 2.2698 11.5144L6.71425 3.51436ZM7.3985 5.15191L10.8045 11.2827L3.99251 11.2827L7.3985 5.15191ZM3.99251 12.7173H10.8045L7.3985 18.8481L3.99251 12.7173ZM8.59401 19.5654H15.406L12 13.4346L8.59401 19.5654ZM13.1955 12.7173L16.6015 18.8481L20.0075 12.7173H13.1955ZM20.0075 11.2827H13.1955L16.6015 5.15191L20.0075 11.2827ZM15.406 4.43461L8.59401 4.43461L12 10.5654L15.406 4.43461Z'
          fill={colored ? 'transparent' : color}
        />
        {/* colored */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.57911 3.75684C6.42774 3.90821 6.29529 4.0785 6.20068 4.24879L2.01904 11.5146H11.0635L6.57911 3.75684Z'
          fill={colored ? '#E10500' : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.5128 3.09461C16.3047 3.03784 16.0966 3 15.8884 3H8.11171C7.90358 3 7.69544 3.03784 7.4873 3.09461L11.9906 10.8524L16.5128 3.09461Z'
          fill={colored ? '#F73232' : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.8181 19.9538L21.9998 12.6123H12.9932L17.4586 20.4647C17.5911 20.3133 17.7235 20.143 17.8181 19.9538Z'
          fill={colored ? '#FF7061' : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.4873 20.9565C7.69544 21.0133 7.90358 21.0511 8.11171 21.0511H15.8884C16.0966 21.0511 16.3047 21.0133 16.5128 20.9565L12.0095 13.1987L7.4873 20.9565Z'
          fill={colored ? '#FC8D7E' : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2 12.6121L6.18164 19.9536C6.29517 20.1428 6.4087 20.3131 6.56007 20.4456L11.0255 12.5932H2V12.6121ZM22 11.439L17.8183 4.09743C17.7237 3.90821 17.5913 3.73792 17.4399 3.60547L12.9744 11.4579H22V11.439Z'
          fill={colored ? '#FC5047' : 'transparent'}
        />
      </>
    ),
    [colored],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'xandr-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Xandr;
